module.exports = __webpack_public_path__ + "img/ResetPasswordIcon.fe6c9fc6.svg";